import { render, staticRenderFns } from "./FundSeat.vue?vue&type=template&id=64aea6f6"
import script from "./FundSeat.vue?vue&type=script&lang=js"
export * from "./FundSeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports